/**
 * @generated SignedSource<<c236c741ad350abd4586ec02c34c1e89>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ContentColumn_FeedbackFragment$data = {
  readonly learnOpportunity: {
    readonly structureDefinition: {
      readonly title: string;
    };
  } | null | undefined;
  readonly " $fragmentType": "ContentColumn_FeedbackFragment";
};
export type ContentColumn_FeedbackFragment$key = {
  readonly " $data"?: ContentColumn_FeedbackFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentColumn_FeedbackFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentColumn_FeedbackFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LearnOpportunityV2",
      "kind": "LinkedField",
      "name": "learnOpportunity",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "structureDefinition",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "FeedbackV2",
  "abstractKey": null
};

(node as any).hash = "0d7ca68ff9b82f966ba9151c6c54cca0";

export default node;
